module.exports = __webpack_public_path__ + "img/warehousingentrynoselected.1519818e.jpg";